import { action, makeObservable, observable } from "mobx";
import { FilterItem } from "../../api/Types";
import { FilterCondition } from "../../constants/Enums";

export default class Filter {
  filterItems: FilterItem[] = [];

  constructor() {
    makeObservable(
      this,
      {
        filterItems: observable,
        setFilterItem: action,
        setFilterItems: action,
        setFilterItemsWithoutFilter: action,
        toggleFilterItem: action,
      },
      {
        deep: true,
      },
    );
  }

  deleteFilterItem = (filterName: string) => {
    const index = this.filterItems.findIndex((i) => i.fieldName === filterName);
    if (index > -1) {
      this.filterItems.splice(index, 1);
    }
  };

  setFilterItems = (values: any) => {
    this.filterItems = Object.keys(values)
      .map((key) => {
        if (!isNaN(values[key]?.conditionType)) {
          const item: FilterItem = {
            fieldName: key,
            value: values[key].value,
            condition: values[key].conditionType,
          };
          if (values[key].conditionType === FilterCondition.Between) {
            item.valueTo = values[key].valueTo;
          }
          return item;
        }
        const item: FilterItem = {
          fieldName: key,
          value: values[key],
          condition: FilterCondition.Equal,
        };
        return item;
      })
      .filter((field) => field.value != null);
  };

  setFilterItemsWithoutFilter = (values: any) => {
    this.filterItems = Object.keys(values).map((key) => {
      if (!isNaN(values[key]?.conditionType)) {
        const item: FilterItem = {
          fieldName: key,
          value: values[key].value,
          condition: values[key].conditionType,
        };
        if (values[key].conditionType === FilterCondition.Between) {
          item.valueTo = values[key].valueTo;
        }
        return item;
      }
      const item: FilterItem = {
        fieldName: key,
        value: values[key],
        condition: FilterCondition.Equal,
      };
      return item;
    });
  };

  setFilterItem = (
    name: string,
    value: any,
    condition: FilterCondition = FilterCondition.Equal,
    valueTo?: any,
  ): void => {
    const foundIdx = this.filterItems.findIndex((i) => i.fieldName === name);

    if (foundIdx >= 0) {
      this.filterItems[foundIdx].value = value;
      this.filterItems[foundIdx].condition = condition;
      if (valueTo) {
        this.filterItems[foundIdx].valueTo = valueTo;
      }
    } else {
      const filter: FilterItem = {
        fieldName: name,
        value: value,
        condition,
      };

      if (valueTo) {
        filter.valueTo = valueTo;
      }
      this.filterItems.push(filter);
    }
  };

  toggleFilterItem = (
    name: string,
    value: any,
    condition: FilterCondition = FilterCondition.Equal,
  ): void => {
    const foundIdx = this.filterItems.findIndex((i) => i.fieldName === name);
    const isValue = value && value !== "";
    if (foundIdx >= 0) {
      if (!isValue) {
        this.filterItems.splice(foundIdx, 1);
      } else {
        this.filterItems[foundIdx].value = value;
        this.filterItems[foundIdx].condition = condition;
      }
    } else {
      this.filterItems.push({
        fieldName: name,
        value: value,
        condition,
      });
    }
  };
}
